import { breakPoints } from '../helpers/breakPoints';
const breakPoint = breakPoints.tablet;
const video = () => {
    const videoSections = document.querySelectorAll('.shopify-section--video');
    if (videoSections) {
        Array.from(videoSections).forEach((videoElem) => {
            const playButton = videoElem.querySelector('.video-play-button');
            const contentToHide = videoElem.querySelectorAll('.prose, .video-image--image');
            const iframe = videoElem.querySelector('iframe');
            const desktopVideo = videoElem.querySelector('.desktop-video');
            const mobileVideo = videoElem.querySelector('.mobile-video');
            if (playButton) {
                playButton.addEventListener('click', () => {
                    contentToHide.forEach((elem) => (elem.style.display = 'none'));
                    if (iframe) {
                        iframe.src += '&autoplay=1';
                    }
                    if (desktopVideo) {
                        if (!mobileVideo) {
                            desktopVideo.play();
                        }
                        else if (window.innerWidth > breakPoint) {
                            desktopVideo.play();
                        }
                        else if (window.innerWidth <= breakPoint) {
                            mobileVideo.play();
                        }
                    }
                });
            }
        });
    }
};
export { video };
